<template>
  <div class="body">
    <a-form
      layout="inline"
      :model="formState"
      :rules="rules"
      @validate="handleValidate"
    >
      <a-drawer
        :visible="visible"
        class="custom-class"
        title="高级查询"
        placement="right"
        :maskClosable="false"
        @close="onClose"
        @after-visible-change="afterVisibleChange"
        :width="400"
      >
        <a-form-item
          label="动作时间:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
        <a-range-picker v-model:value="formState.operaTime" class="selectTime" />
        </a-form-item>
        <a-form-item
          label="终端id:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-input v-model:value="formState.termId" style="width: 219px" />
        </a-form-item>
        <a-form-item
          label="省份:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-select
            mode="multiple"
            size="default"
            show-search 
           :filter-option="filterOption"
            style="width: 219px"
            @change="handleChange1"
            :maxTagCount="2"
            v-model:value="modelProvinces"
          >
            <a-select-option
              :value="item.regionCode"
              v-for="item in provinces"
              :key="item.id"
              :label="item.regionName"
            >
              {{ item.regionName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="市区:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-select
            mode="multiple"
            size="default"
            show-search 
            :filter-option="filterOption1"
            :maxTagCount="2"
            style="width: 219px"
            @change="handleChange2"
            v-model:value="modelCitys"
          >
            <a-select-option
              :value="`${item.parentCode}/${item.regionCode}`"
              v-for="item in citys"
              :key="item.id"
              :label="item.regionName"
            >
              {{ item.regionName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="基层单位:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-select
            mode="multiple"
            size="default"
            show-search 
            :filter-option="filterOption2"
            :maxTagCount="1"
            style="width: 219px"
            @change="handleChange3"
            v-model:value="modeljiCengs"
          >
            <a-select-option
              :value="`${item.province}/${item.city}-${item.companyId}`"
              v-for="(item, index) in jiCengs"
              :key="index"
              :label="item.companyName"
            >
              {{ item.companyName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="变电站名称:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-select
            mode="multiple"
            size="default"
            show-search 
            :filter-option="filterOption3"
            style="width: 219px"
            :maxTagCount="1"
            @change="handleChange4"
            v-model:value="modelBianDianZhan"
          >
            <a-select-option
              :value="item.substationId"
              v-for="(item, index) in bianDianZhans"
              :key="index"
              :label="item.substationName"
            >
              {{ item.substationName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="隔刀厂家:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-input
            v-model:value="formState.switchFactor"
            style="width: 219px"
          />
        </a-form-item>
        <a-form-item
          label="隔刀型号:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-input v-model:value="formState.switchModel" style="width: 219px" />
        </a-form-item>
        <a-form-item
          label="隔刀类型:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-select
            size="default"
            style="width: 219px"
            v-model:value="formState.switchType"
          >
            <a-select-option value="1"> 隔离开关 </a-select-option>
            <a-select-option value="2"> 接地开关 </a-select-option>
            <a-select-option value="3"> 三工位开关 </a-select-option>
            <a-select-option value="4"> 快速接地开关 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="电机用途:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-select
            size="default"
            default-value=""
            style="width: 219px"
            v-model:value="formState.motorApply"
          >
            <a-select-option value="1"> 驱动电机 </a-select-option>
            <a-select-option value="2"> 储能电机 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="电机型式:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-select
            size="default"
            style="width: 219px"
            v-model:value="formState.motorType"
          >
            <a-select-option value="1"> 三相电机 </a-select-option>
            <a-select-option value="2"> 单相电机 </a-select-option>
            <a-select-option value="3"> 直流电机 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="操动方式:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-select
            size="default"
            style="width: 219px"
            v-model:value="formState.operaMode"
          >
            <a-select-option value="1"> 电气联动 </a-select-option>
            <a-select-option value="2"> 机械联动 </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="始用年份:"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 15 }"
        >
          <a-date-picker
            v-model:value="formState.startYear"
            picker="year"
            style="width: 219px"
          />
        </a-form-item>
        <div class="footer" style="height: 50px; border-top: 1px solid #ffffff">
          <a-form-item>
            <a-button
              html-type="submit"
              @click="refresh"
              class="button"
              style="margin-right: 10px"
              >查询</a-button
            >
            <a-button @click="handleReset2" class="button"> 重置 </a-button>
          </a-form-item>
        </div>
      </a-drawer>
    </a-form>
    <div class="head">
      <div style="display: flex">
        <div style="margin-right: 90px">
          <span class="fontcolor">动作时间</span>
          <a-range-picker v-model:value="formState.operaTime" />
        </div>
        <div style="margin-right: 90px">
          <span class="fontcolor">终端id</span>
          <a-input v-model:value="formState.termId" />
        </div>
      </div>
      <div>
        <a-button class="button" @click="chaxun">查询</a-button>
        <a-button class="button" style="margin: 0px 10px" @click="reset"
          >重置</a-button
        >
        <a-button class="button" @click="showDrawer">高级查询</a-button>
      </div>
    </div>
    <!---->
    <div class="content" ref="content">
      <div class="content1">
        <a-button class="button" @click="uploadTP">下载图谱</a-button>
        <a-button class="button" style="margin: 0px 10px" @click="uploadSJ"
          >下载数据</a-button
        >
        <a-button class="button" @click="exportDataStats">下载台账</a-button>
      </div>
      <div class="content2">
        <a-table
          :columns="columns"
          :data-source="data"
          :row-class-name="rowClassName"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          :row-key="record => record.id"
          :pagination="pagination"
          @change="changePage"
          :scroll="{ y: heightWidth }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'termId'">
              <a @click="showTuPu(record)">{{ record.termId }}</a>
            </template>
            <template v-if="column.dataIndex === 'serverType'">
             <div v-if="record.serverType == 1">站端</div>
             <div v-if="record.serverType == 2">便携端</div>
            </template>
          </template>
        </a-table>
        <div v-show="isShowPhoto">
        <div class="chartPhoto" ref="chartPhoto">
          <div class="chart_head">{{title}}</div>
          <div id="div1" class="chartStyle" style="width:1180px;height:532px" ref="aaa"></div>
          <img src="@/style/img/关闭.png" class="close" @click="closeChart">
           <img src="@/style/img/左上.png" alt="" class="info_lt" style="top:-1px ;left:-1px">
          <img src="@/style/img/左下.png" alt="" class="info_lb" style="bottom:-1px ;left:-1px">
          <img src="@/style/img/右上.png" alt="" class="info_rt" style="top:-1px ;right:-1px">
          <img src="@/style/img/右下.png" alt="" class="info_rb" style="bottom:-1px ;right:-1px">
        </div>
        <div class="chart_bg" @click="closeChart"></div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { message } from "ant-design-vue";
import exportFunc from "@/utils/export-utils";
import * as echarts from "echarts";
import {
  getList,
  getJiCeng,
  getProvice,
  getCity,
  getBianDianZhan,
  getHisDataMap,
  downloadMap,
  downloadData
} from "@/api/dataStat.js";
export default {
  created() {},
  mounted() {
      addEventListener('resize',this.onWidnowResize)
      this.onWidnowResize()
      this.getProvices()
      let params = {
        pagenum:this.pagination.current,
        pagesize:this.pagination.pageSize,
        operaStartTime:this.formState.operaTime[0].format("YYYY-MM-DD"),//这两个时间
        operaEndTime:this.formState.operaTime[1].format("YYYY-MM-DD"),
      } 
      this.getLists(params)
      
  },
  beforeUnmount() {
    removeEventListener('resize',this.onWidnowResize)
  },
  components: {},
  data() {
    this.charts1 = null
    let date = new Date().getFullYear();
    return {
      isupload: true,
      baseUrls: [],
      formState: {
        operaTime: [dayjs(`${date}-01-01`, "YYYY-MM-DD"), dayjs()], //动作时间
        termId: null,
        provinces: [],//省份
        citys: [],//城市
        jicengs: [],//基层
        substationId: [],//变电站
        switchFactor: null,
        switchModel: null,
        switchType: null,
        motorApply: null,
        motorType: null,
        operaMode: null,
        startYear: null,
        //dayjs()
      },
      data: [],
      columns: [
        {
          title: "动作时间",
          dataIndex: "operaTime",
          key: "operaTime",
        },
        {
          title: "终端id",
          dataIndex: "termId",
          key: "termId",
        },
        {
          title: "省份",
          dataIndex: "provinceName",
          key: "provinceName",
        },
        {
          title: "城市",
          dataIndex: "cityName",
          key: "cityName",
        },
        {
          title: "基层单位",
          dataIndex: "companyName",
          key: "companyName",
        },
        {
          title: "变电站名称",
          dataIndex: "substationName",
          key: "substationName",
        },
        {
          title: "隔刀厂家",
          dataIndex: "switchFactor",
          key: "switchFactor",
        },
        {
          title: "隔刀型号",
          dataIndex: "switchModel",
          key: "switchModel",
        },
        {
          title: "隔刀类型",
          dataIndex: "switchType",
          key: "switchType",
        },
        {
          title: "电机用途",
          dataIndex: "motorApply",
          key: "motorApply",
        },
        {
          title: "电机型式",
          dataIndex: "motorType",
          key: "motorType",
        },
        {
          title: "操动方式",
          dataIndex: "operaMode",
          key: "operaMode",
        },
        {
          title: "始用年份",
          dataIndex: "startYear",
          key: "startYear",
        },
        {
          title: "服务类型",
          dataIndex: "serverType",
          key: "serverType",
        },
      ],
      flag: null,
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        pageSizeOptions: ["10", "20", "30", "50", "100"],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal : (total => `共${total}条`)
      },
      title: null,
      rows: [],
      selectedRowKeys: [],
      // selectedRows: [],
      visible: false,
      //省
      modelProvinces :[],
      provinces:[],
      //市
      modelCitys:[],
      citys:[],
      //基层
      modeljiCengs:[],
      jiCengs :[],
      //变电站
      modelBianDianZhan:[],
      paramss:[],
      bianDianZhans:[],

      content:null,
      heightWidth:100,
      //展示图谱
      isShowPhoto:false,
      xData:[],
      showTuList:[],
      tupuMessage:{}
    };
  },
  watch:{
    modelProvinces:{
      handler(newval){
        this.modelCitys = this.modelCitys.filter(item =>{
        let a = item.slice(0,item.indexOf("/"))
        let flag = false
        newval.forEach(items => {
          if(items == a ){
            flag = true
          }
        })
        if(flag) {return item}
      })
      },
    },
    modelCitys:{
      handler(newval){
        let b = this.modeljiCengs.filter(item => {
          let a = item.slice(0,item.indexOf('-'))
          let flag = false
          newval.forEach(items => {
            if(items == a){
              flag = true
            }
          })
          if(flag){return item}
        })
        this.modeljiCengs = b
      }
    },
   modeljiCengs:{
    handler(newval){
      let b= this.modelBianDianZhan.filter(item => {
        let a = item.slice(0,2)
        let b = item.slice(2,4)
        let c = item.slice(4,6)
        let str = a+'/'+b+'-'+c
        let flag = false
        newval.forEach(items => {
          if(items == str){
            flag = true
          }
        })
        if(flag){return item}
      })
      this.modelBianDianZhan = b
    },
     immediate:true 
   }

  },
  methods: {
    //省份过滤
    filterOption(inputValue,option){
      if(option.label.indexOf(inputValue) != -1){return true}
      else{
        return false
      }
    },
    //市区过滤
    filterOption1(inputValue,option){
      if(option.label.indexOf(inputValue) != -1){return true}
      else{
        return false
      }
    },
    //基层过滤
    filterOption2(inputValue,option){
      if(option.label.indexOf(inputValue) != -1){return true}
      else{
        return false
      }
    },
    //变电站名称过滤
    filterOption3(inputValue,option){
      if(option.label.indexOf(inputValue) != -1){return true}
      else{
        return false
      }
    },
    //echarts
    initcharts(){
     this.charts1 = echarts.init(this.$refs.aaa);
     this.xData = []
     this.xData = this.showTuList.map(item => {
        return  `${item.time * 20 / 1000}`
      })
      this.xData.unshift(0)
      let pData = this.showTuList.map(item => {
        return [`${item.time * 20 / 1000}`,item.p];
      })
      let xdata = this.xData;
      let arrindex = Number(xdata[xdata.length - 1])
      let arrindex2 = Math.ceil(arrindex)
      while (arrindex < arrindex2) {
        xdata.push(`${parseFloat((arrindex + 0.02).toFixed(2))}`);
        arrindex+= 0.02;
    }
    this.xData = xdata;
           const option ={
            animation: false,
              title: [
                    {
                      text: "终端编号：" + `${this.tupuMessage.termId}\n` + 
                      "动作时间：" + `${this.tupuMessage.operaTime}\n`+
                      "变电站："+`${this.tupuMessage.substationName}\n`+
                      "终端位置："+`${this.tupuMessage.companyName}\n`+
                      "隔刀编号："+`${this.tupuMessage.switchCode}\n`+
                      "隔刀型号："+`${this.tupuMessage.switchModel}\n`+
                      "隔刀类型："+`${this.tupuMessage.switchType}\n`+
                      "隔刀厂家："+`${this.tupuMessage.switchFactor}\n`,
                      left: '72%',
                      top: '20%',
                      textStyle: {
                      color: "#ffffff",
                      fontSize: 14,
                      fontWeight: 'normal',
                      lineHeight: 30,
                      }
                    },
                    ],
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: this.xData,
                name:'t(s)',
                nameLocation:'end',
                nameTextStyle:{
                  color:"#fff",
                  verticalAlign:"bottom"
                  },
                axisLine : {
                    lineStyle : {
                      color: this.isupload ? '#16b2b4' : '#ccc',
                    }
                   },
                axisLabel : {
                  interval: 0,
                    color:'#FFFFFF',
                    fontFamily : ' Microsoft YaHei, Microsoft YaHei-Regular',
                    formatter: function(data){                      
                          if((Number(data) % 1) == 0) {
                            return data
                          }
                  }
                   },
                axisTick: {
                show: true,
                interval: 9,
                inside: true,
              },
              splitLine: {
                show: true,
                interval: 49,
                lineStyle: {
                  color:  this.isupload ? '#10585A' : '#ccc'
                }
              },
              },
              yAxis: {
                type: 'value',
                 name:'P(W)',
                //分隔线
                  splitLine : {
                  lineStyle : {
                    color : this.isupload ? '#10585A' : '#ccc',
                  }
                  },
                  axisLine : {
                    show : true,
                    nameTextStyle : {
                    color:"#fff"
                   },
                    lineStyle : {
                      color:'#16b2b4'
                    }
                   },
                  axisLabel : {
                    color:'#FFFFFF',
                    fontFamily : ' Microsoft YaHei, Microsoft YaHei-Regular',
                   },
                nameLocation:'end',
                nameTextStyle:{color:"#fff",}
              },
              dataZoom : [
                {
                    type:'inside',
                    xAxisIndex:0,
                    start: 0,
                    enf: 100,
                  },
                  {
                    type:'inside',
                    yAxisIndex:0,
                    start: 0,
                    enf: 100,
                  },
                  {
                    type: 'slider',
                    show: this.isupload,
                    yAxisIndex: [0],
                    left: '1%',
                    start: 0,
                    end: 100,
                    textStyle: {
                      color:'#fff'
                    }
                  },
                  ],
              grid:{
                left:"100px",
                right:'30%',
                top:50,
                bottom:40,
                borderWidth: 1,
                z: 99999,
                borderColor: this.isupload ? '16b2b4' : '#000',
                show: true,
              },
              tooltip : {
                show : true,
                trigger : 'axis',
                backgroundColor:'rgba(117,143,150,0.5)',
                borderColor:'transparent',
                textStyle : {
                  color:'#fff'
                }
                },
              series: [
                {
                  data: pData,
                  type: 'line',
                  smooth: true,
                  showSymbol: this.isupload
                }
              ]
           }
            this.charts1.setOption(option);
    },
    //查询
    chaxun() {
      this.pagination.current = 1
      this.pagination.pageSize = 10
      this.flag = true;
      let params = {
        pagenum: this.pagination.current,
        pagesize: this.pagination.pageSize,
        operaStartTime:this.formState.operaTime == null ? null : this.formState.operaTime[0].format('YYYY-MM-DD'),
        operaEndTime:this.formState.operaTime == null ? null : this.formState.operaTime[1].format('YYYY-MM-DD'),
        termId: this.formState.termId,
      };
      this.getLists(params);
    },
    //重置
    reset() {
      this.flag = true;
      this.pagination.current = 1
      this.pagination.pageSize = 10
      let date = new Date().getFullYear();
      (this.formState.operaTime = [
        dayjs(`${date}-01-01`, "YYYY-MM-DD"),
        dayjs(),
      ]), //动作时间
        (this.formState.termId = null);
        this.selectedRowKeys = []
        let params = {
        pagenum: this.pagination.current,
        pagesize: this.pagination.pageSize,
        operaStartTime:this.formState.operaTime == null ? null : this.formState.operaTime[0].format('YYYY-MM-DD'),
        operaEndTime:this.formState.operaTime == null ? null : this.formState.operaTime[1].format('YYYY-MM-DD'),
        termId: this.formState.termId,
      };
      this.getLists(params);
    },
    //分页
    changePage(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      if (this.flag == true || this.flag == null) {
        let params = {
          pagenum: this.pagination.current,
          pagesize: this.pagination.pageSize,
          operaStartTime:this.formState.operaTime == null ? null : this.formState.operaTime[0].format('YYYY-MM-DD'),
          operaEndTime:this.formState.operaTime == null ? null : this.formState.operaTime[1].format('YYYY-MM-DD'),
          termId: this.formState.termId,
        };
        this.getLists(params);
      } else if (this.flag == false) {
        //高级查询
              let str = this.formState.substationId.join(",")
              // let str1 ="{"+str+"}"
              let params = {
              pagenum:this.pagination.current,
              pagesize:this.pagination.pageSize,
              operaStartTime:this.formState.operaTime == null ? null : this.formState.operaTime[0].format('YYYY-MM-DD'),
              operaEndTime:this.formState.operaTime == null ? null : this.formState.operaTime[1].format('YYYY-MM-DD'),
              termId:this.formState.termId,
              substationId:str || null,
              switchFactor:this.formState.switchFactor,
              switchModel:this.formState.switchModel,
              switchType:this.formState.switchType,
              motorApply:this.formState.motorApply,
              motorType:this.formState.motorType,
              operaMode:this.formState.operaMode,
              startYear:this.formState.startYear == null ? null : this.formState.startYear.format('YYYY'),
              areaParam:this.paramss
              }
              this.getLists(params)
      }
    },

    //获取列表
    getLists(params) {
      getList(params).then((res) => {
        this.pagination.total = res.data.total;
        this.data = res.data.rows;
        this.data.forEach(item => {
          switch(item.switchType){
              case 1:{item.switchType = '隔离开关';break;}
              case 2:{item.switchType ='接地开关';break;}
              case 3:{item.switchType = '三工位开关';break;}
              case 4:{item.switchType = '快速接地开关';break;}
            }
          switch(item.motorApply){
              case 1:{item.motorApply = '驱动电机';break;}
              case 2:{item.motorApply ='储能电机';break;}
            }
          switch(item.motorType){
              case 1:{item.motorType = '三相电机';break;}
              case 2:{item.motorType ='单相电机';break;}
              case 3:{item.motorType ='直流电机';break;}
            }
          switch(item.operaMode){
              case 1:{item.operaMode = '电气联动';break;}
              case 2:{item.operaMode ='机械联动';break;}
            }
        })
      });
    },
        //通过终端id查询图谱
    getHisDataMaps(termId) {
      return new Promise((resolve, reject) => {
        getHisDataMap({ termId: termId }).then((res) => {
          // console.log(res)
          this.showTuList = res.data
          this.initcharts()
          resolve()
        });
      })
    },
    showTuPu(e) {
      this.isupload = true;
      this.tupuMessage = e
      this.title = e.termId+'——'+e.operaTime;
      this.isShowPhoto = true
      this.getHisDataMaps(e.id);
    },
    //关闭echart弹窗
    closeChart() {
        this.charts1.dispose();
        this.charts1 = null;
        this.isShowPhoto = false;
    },
    jpegImage() {  
      this.exportEcharts('jpeg格式的图片.jpeg', 'div1', 'jpeg')
    },
    pngImage(row) {
      this.exportEcharts('png格式的图片.png', 'div1', 'png',row)
    },
    //title图表的标题，echartsBox放图表容器的名字，type图表的类型
    exportEcharts(title, echartsBox, type, row) {

      // let myChart = echarts.getInstanceByDom(document.getElementById("div1"));
      // if (!myChart) {
      //   myChart = echarts.init(document.getElementById(echartsBox));
      // }
     let option = this.charts1.getOption();
      option.xAxis[0].nameTextStyle.color = '#000';
      option.xAxis[0].axisLabel.color = '#000';
      option.yAxis[0].nameTextStyle.color = '#000';
      option.yAxis[0].axisLabel.color = '#000';
      option.title[0].textStyle.color = '#000';
      this.charts1.setOption(option);
      let picInfo = this.charts1.getDataURL({
        type: type,
        pixelRatio: 1,
        backgroundColor: '#fff',
      }); //base64 
      // debugger
      this.baseUrls.push({
          imgString: picInfo,
          operaTime: row.operaTime,
          termId: row.termId,
      })
    },
    //下载图谱
    async uploadTP() {
      if (this.rows.length <= 0) {
        message.warning("请至少选择一行数据");
      } else {
        this.isupload = false;
        this.baseUrls = [];
        for (let i = 0; i < this.rows.length; i++) {
          this.tupuMessage = this.rows[i];
          await this.getHisDataMaps(this.rows[i].id);
          this.pngImage(this.rows[i]);
        }
        downloadMap(this.baseUrls).then((res) => {
          this.charts1.dispose();
           this.downloadZip(res, '图形', 'zip');
        });
      }
    },
                /**
 * 下载压缩包文件
 * @param {blob} fileArrayBuffer 文件流
 * @param {String} filename 文件名称
 * @param {String} fileType 文件格式
 */
 downloadZip(fileArrayBuffer, filename, fileType) {
            let data = new Blob([fileArrayBuffer], { type: fileType == 'zip' ? 'application/zip,charset=utf-8' : 'application/x-rar-compressed,charset=utf-8' });
            if (typeof window.chrome !== 'undefined') {
                // Chrome
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(data);
                link.download = filename;
                link.click();
                // console.log(data);
            } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
                // IE
                var blob = new Blob([data], { type: fileType == 'zip' ? 'application/zip' : 'application/x-rar-compressed' });
                window.navigator.msSaveBlob(blob, filename);
            } else {
                // Firefox
                var file = new File([data], filename, { type: fileType == 'zip' ? 'application/zip' : 'application/x-rar-compressed' });
                window.open(URL.createObjectURL(file));
            }
        },
    //下载数据
    uploadSJ() {
      if (this.rows.length <= 0) {
        message.warning("请至少选择一行数据");
      } else {
        downloadData(this.selectedRowKeys).then((res) => {
           this.downloadZip(res, '数据', 'zip');
        });
      }
    },
    //下载台账
    exportDataStats() {
      let date = new Date()
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m >=10 ? m:'0'+m
      let d = date.getDate() 
      d = d >=10 ? d:'0'+d
      let hours = date.getHours()
      hours = hours >=10 ? hours:'0'+hours
      let mints = date.getMinutes()
      mints = mints >=10 ? mints:'0'+mints
      let strName = y+m+d+hours+mints
      let href = `/yunDuanUrl/dmsm-service-cloud/dataStat/exportDataStat`;
      exportFunc(href, "post", JSON.stringify(this.selectedRowKeys), "application/json",strName+'台账');
    },
    //表格选中事件
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.rows = selectedRows;
    },

    //高级查询
    showDrawer() {
      //表格清空重置
      // let date = new Date().getFullYear();
      // this.formState.operaTime = [dayjs(`${date}-01-01`, 'YYYY-MM-DD'), dayjs()],//动作时间
      // this.formState.termId = null
      // this.formState.switchFactor = null,
      // this.formState.switchModel = null,
      // this.formState.motorApply = null
      // this.formState.switchType = null,
      // this.formState.motorType = null,
      // this.formState.operaMode = null,
      // this.formState.startYear = dayjs()
      // this.modelCitys = []
      // this.modelBianDianZhan  = []
      // this.modelProvinces  = []
      // this.modeljiCengs = []
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    refresh(){
      this.pagination.current = 1
      this.pagination.pageSize = 10
      this.flag = false
      let str = this.formState.substationId.join(",")
      // let str1 ="{"+str+"}"
      let params = {
      pagenum:this.pagination.current,
      pagesize:this.pagination.pageSize,
      operaStartTime:this.formState.operaTime == null ? null : this.formState.operaTime[0].format('YYYY-MM-DD'),
      operaEndTime:this.formState.operaTime == null ? null : this.formState.operaTime[1].format('YYYY-MM-DD'),
      termId:this.formState.termId,
      substationId:str || null,
      switchFactor:this.formState.switchFactor,
      switchModel:this.formState.switchModel,
      switchType:this.formState.switchType,
      motorApply:this.formState.motorApply,
      motorType:this.formState.motorType,
      operaMode:this.formState.operaMode,
      startYear:this.formState.startYear == null ? null : this.formState.startYear.format('YYYY'),
      areaParam:this.paramss
      }
       this.getLists(params)
       this.visible = false;
    },
    //重置
    handleReset2(){
      let date = new Date().getFullYear();
      this.formState.operaTime = [dayjs(`${date}-01-01`, 'YYYY-MM-DD'), dayjs()],//动作时间
      this.formState.termId = null
      this.formState.switchFactor = null,
      this.formState.switchModel = null,
      this.formState.motorApply = null
      this.formState.switchType = null,
      this.formState.motorType = null,
      this.formState.operaMode = null,
      this.formState.startYear = null
      this.modelCitys = []
      this.modelBianDianZhan = []
      this.modelProvinces = []
      this.modeljiCengs = []
      this.paramss = []
    },
    //省
    getProvices(){
      getProvice().then(res => {
        this.provinces= res.data
      })
    },
    handleChange1(value){
      //为空就清空城市，不让查询全部
      if(this.modelProvinces.length == 0){
        this.citys = []
        this.paramss = []
        return
      }
      this.modelCitys = []
      this.modeljiCengs = []
      this.modelBianDianZhan = []
      this.paramss = []
      this.paramss = value.map(item => {
        return{
          "province":item,
          "city":null,
          "companyId":null
        }
      })
      this.formState.provinces = value
      this.getCitys()
    },

    //市
    getCitys(){
      getCity({
        regionCode:this.formState.provinces
      }).then(res => {
          this.citys = res.data
      })
    },
    handleChange2(value){
      //为空就清空基层，不让查询全部
      let flag = true
     if(this.modelCitys.length == 0){
        this.jiCengs = []
        this.paramss = value.map(item => {
          return{
            "province":item.slice(0,item.indexOf("/")),
            "city":null,
            "companyId":null
          }
        })
  
      }
      this.modeljiCengs = []
      this.modelBianDianZhan = []
      this.paramss = []
      this.paramss = value.map(item => {
          return{
            "province":item.slice(0,item.indexOf("/")),
            "city":item.slice(item.indexOf('/')+1,item.length+1),
            "companyId":null
          }
        })
        //
        let arrList = this.paramss.map(ele => {
            return ele.province
          })
        this.modelProvinces.forEach(item => {
             if(arrList.indexOf(item) == -1){
                this.paramss.push(
                  {
                  "province":item,
                  "city":null,
                  "companyId":null
                  }
                )
             }

        })

      this.formState.citys = value
      //市为空就不让查询基层
      if(flag){
        this.getJiCengs()
      }
    },
    //基层
    getJiCengs(){
      //  console.log(this.formState.citys,'--citys')
       let city = this.formState.citys.map(item => {
       let b = item.slice(item.indexOf('/')+1,item.length+1)
       let a = item.slice(0,item.indexOf('/'))
       return {
        "province":a,
        "city":b
       }
      })
      getJiCeng(city).then(res => {
        // console.log(city,'---')
        this.jiCengs = res.data
      })
    },
    handleChange3(value){
    //  console.log(value,'value')
    //为空就清空站点，不让查询全部
    let flag = true
     if(this.modeljiCengs.length == 0){
        this.bianDianZhans = []
        this.paramss = value.map(item => {
        return{
              "province":item.slice(0,item.indexOf("/")),
              "city":item.slice(item.indexOf('/')+1,item.indexOf('-')),
              "companyId":null
            }
        })
        flag = false
      }
      this.modelBianDianZhan = []
      let obj = JSON.parse(JSON.stringify(this.paramss))
      this.paramss = []
      this.paramss = value.map(item => {
      return{
            "province":item.slice(0,item.indexOf("/")),
            "city":item.slice(item.indexOf('/')+1,item.indexOf('-')),
            "companyId":item.slice(item.indexOf('-')+1,item.length)
          }
      })
      let arrList = value.map(item => {
        return item.slice(0,item.indexOf("-"))
      })
      this.modelCitys.forEach(item => {
         if(arrList.indexOf(item) == -1){
           this.paramss.push({
             "province":item.slice(0,item.indexOf("/")),
             "city":item.slice(item.indexOf('/')+1,item.length),
             "companyId":null
           })
         }
      })
      obj.forEach(item => {
        if(item.province && item.city == null) {
          this.paramss.push({
            "province":item.province,
            "city":null,
            "companyId":null
          })
        }
      })
      // let arrList = this.paramss.map(ele => {
      //    return ele.city
      // })
      // this.modelCitys.forEach(item => {
      //     let index = item.slice(item.indexOf('/')+1,item.length)
      //     if(arrList.indexOf(index) == -1){
      //       this.paramss.push({
      //         "province":item.slice(0,item.indexOf("/")),
      //         "city":item.slice(item.indexOf('/')+1,item.length),
      //         "companyId":null
      //       })
      //     }
      // })
      this.formState.jicengs = value
      if(flag){
          this.getBianDianZhans()
      }
    },

      //变电站
     getBianDianZhans(){
       let params = this.formState.jicengs.map(item => {
       let a = item.slice(0,item.indexOf('/'))  
       let b = item.slice(item.indexOf('/')+1,item.indexOf('-'))
       let c = item.slice(item.indexOf('-')+1,item.length)
        return {
          "province":a,
          "city":b,
          "companyId":c
        }
      })
        getBianDianZhan(params).then(res => {
          this.bianDianZhans = res.data
        })
    },
    handleChange4(value){
      this.formState.substationId = value
      this.getBianDianZhans()
    },

    //大小
    onWidnowResize(){
    let contentWidth = this.$refs.content.clientHeight - 90 - 64;
    this.heightWidth= contentWidth;
    let container = document.querySelector('.ant-table-body');
    container.style.height = contentWidth + 'px';
  },
  //样式
  rowClassName(_record,index) {
    return index % 2 === 0 ? 'table-striped' : null;
  },
  },
};
</script>

<style scoped lang="less">
.fontcolor {
  color: #08decf;
  margin-right: 10px;
}
.body {
  height: 100%;
}

.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 20px);
  height: 80px;
  margin: 0px 10px;
  overflow: hidden;
  padding: 0px 157px 0px 40px;
  background: linear-gradient(144deg, #25404e 0%, #2f5c74 100%);
  border: #2b76a1 solid 2px;
}

.content {
  position: relative;
  width: calc(100% - 20px);
  height: calc(100% - 100px);
  margin: 10px;
  background: linear-gradient(-31deg, #3a5e78 0%, #15273f 100%);
  border: #2b76a1 solid 2px;

  .content1 {
    position: absolute;
    top: 10px;
    left: 40px;
    z-index: 100;
  }
}

::v-deep .ant-input {
  width: 180px;
}

::v-deep .ant-select-multiple .ant-select-selection-item-content {
  color: #292d36;
}

.button {
  background: linear-gradient(-45deg, #0c96b1 0%, #0fbca1 100%);
  border: 1px solid;
  border-image: linear-gradient(-45deg, #0eb4dd 0%, #01efbc 100%) 1 1;
  padding: 0px 23px;
}

::v-deep .ant-select-selection--multiple {
  max-height: 32px;
  overflow: hidden;
}
.ant-picker-range{
  width: 219px !important;
}
.footer {
  display: flex;
  align-items: center;
}

.footer ::v-deep .ant-form-item-control-input-content {
  display: flex;
  justify-content: center;
}
.chart_head {
  background: url('../../style/img/弹窗头.png') no-repeat;
  background-position: center;
  height: 42px;
  margin-bottom: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chartStyle {
  flex: 1;
}
.chartPhoto {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width:1200px;
  height:80%;
  background: linear-gradient(#15273f 0%, #1d3c52 100%);
  border: 1px solid #2b76a1;
  z-index: 100;
  display: flex;
  flex-direction: column;
}
  .info_lt,.info_rb,.info_rt,.info_lb{
      position:absolute;
      z-index: 100;
  }
  .info_lt {
      top: 1px;
      left: 1px;
  }
  .info_rb {
      bottom: 1px;
      right: 1px;
  }
   .info_rt{
      top: 1px;
      right: 1px;
  }
  .info_lb {
      bottom: 1px;
      left: 1px;
  }
    .chart_bg {
    position: absolute;
    top:0;
    left: 0;
    width:100%;
    height:100%;
    background-color:#1f1f1f79;
    z-index:80;
  }
    .close {
    position: absolute;
    top: 0;
    right:0;
    transform :translate(50%,-50%);
    z-index: 200;
    width: 2.4vw;
  }
</style>
<style>
/* 弹窗 */
.ant-drawer-close {
  position: absolute !important;
  right: 0 !important;
}

.ant-drawer-wrapper-body {
  border: 1px solid #08decf !important;
}

.ant-drawer-header {
  background-color: #0a2439 !important;
  border-image: linear-gradient(to right, #1299A2 0%, #20B0BD 100%) 1 1;
}

.ant-drawer-body {
  padding: 0px !important;
  padding-top: 20px !important;
  display: flex;
  background-color: #0a2439 !important;
  flex-direction: column;
}
.footer{
    display: flex;
    align-items: center;
    border-image: linear-gradient(to right, #1299A2 0%, #20B0BD 100%) 1 1;
}
.ant-form-item-label > label,
.ant-drawer-title,
.ant-drawer-close {
  color: #fff;
}
</style>